import React, { useEffect } from 'react';

const GoogleAd = () => {
    useEffect(() => {
        // Load Google AdSense script
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);

        // Initialize ads
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, []);

    return null;
};

export default GoogleAd; 
